"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitReportingFields = exports.determineReportingSourceField = exports.SOURCE_FIELD_SEARCH_AND_OFFICIAL = exports.SOURCE_FIELD_MAPS = exports.MAPS_STORY_TYPE_ENUM = void 0;
exports.MAPS_STORY_TYPE_ENUM = 1;
exports.SOURCE_FIELD_MAPS = 6;
exports.SOURCE_FIELD_SEARCH_AND_OFFICIAL = 3;
const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
const appendParam = (key, data) => `${camelToSnakeCase(key)}=${data}&`;
const determineReportingSourceField = (storyTypeEnum) => {
    if (Number(storyTypeEnum) === exports.MAPS_STORY_TYPE_ENUM) {
        return exports.SOURCE_FIELD_MAPS;
    }
    return exports.SOURCE_FIELD_SEARCH_AND_OFFICIAL;
};
exports.determineReportingSourceField = determineReportingSourceField;
const submitReportingFields = async (fields) => {
    const requestFields = {
        method: "post",
        body: JSON.stringify(fields),
    };
    let url = "https://app.snapchat.com/reporting/onweb/v1/story?";
    const paramFieldKeys = Object.keys(fields);
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < paramFieldKeys.length; i += 1) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        url = url.concat(appendParam(paramFieldKeys[i], fields[paramFieldKeys[i]]));
    }
    url = url.substring(0, url.length - 1);
    url = url.replace("globallivestory~", "");
    return fetch(url, requestFields);
};
exports.submitReportingFields = submitReportingFields;
//# sourceMappingURL=reportingUtils.js.map